import { useState } from 'react';
import type { SelectionModifyKind } from '../../engine/selectionOps';
import { modifySelectionBy } from '../../state/selectionActions';
import { Modal, NumberInput } from '../components/controls';

const TITLES: Record<SelectionModifyKind, { title: string; label: string; note: string }> = {
  border: {
    title: 'Border',
    label: 'Width',
    note: 'Keeps a band centred on the current edge.',
  },
  smooth: {
    title: 'Smooth',
    label: 'Radius',
    note: 'Rounds off corners and removes stray spikes and notches.',
  },
  expand: { title: 'Expand', label: 'Amount', note: 'Grows the selection outwards.' },
  contract: { title: 'Contract', label: 'Amount', note: 'Shrinks the selection inwards.' },
  feather: {
    title: 'Feather',
    label: 'Radius',
    note: 'Softens the edge so everything you paint or fill fades out.',
  },
};

const DEFAULTS: Record<SelectionModifyKind, number> = {
  border: 4,
  smooth: 4,
  expand: 4,
  contract: 4,
  feather: 8,
};

export function ModifySelectionDialog({
  open,
  kind,
  onClose,
}: {
  open: boolean;
  kind: SelectionModifyKind;
  onClose: () => void;
}) {
  const [amount, setAmount] = useState(DEFAULTS[kind]);
  const copy = TITLES[kind];

  const apply = () => {
    modifySelectionBy(kind, amount);
    onClose();
  };

  return (
    <Modal
      open={open}
      title={copy.title}
      onClose={onClose}
      footer={
        <>
          <button type="button" className="button" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="button button--primary" onClick={apply}>
            Apply
          </button>
        </>
      }
    >
      <p className="dialog__note">{copy.note}</p>
      <div className="field">
        <span className="field__label" style={{ width: 66 }}>
          {copy.label}
        </span>
        <NumberInput value={amount} min={1} max={500} onChange={setAmount} />
        <span className="field__suffix">px</span>
      </div>
    </Modal>
  );
}
